export const GET_TEMPLATE = 'GET_TEMPLATE';
export const GET_AGENT = 'GET_AGENT';
export const REDUCE_TEMPLATE = 'REDUCE_TEMPLATE';
export const REDUCE_AGENT = 'REDUCE_AGENT';
